import { render, staticRenderFns } from "./Model18.vue?vue&type=template&id=6166f268&scoped=true"
import script from "./Model18.vue?vue&type=script&lang=js"
export * from "./Model18.vue?vue&type=script&lang=js"
import style0 from "./Model18.vue?vue&type=style&index=0&id=6166f268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6166f268",
  null
  
)

export default component.exports